import { SearchTextInput } from "@/features/common/components/filter/SearchTextInput";
import { useDebouncedSearch } from "@/features/common/hooks/useDebouncedSearch";

type DebouncedSearchInputProps = {
  onDebouncedInputChange: (searchInput: string) => void;
};

export const DebouncedSearchInput = ({
  onDebouncedInputChange,
}: DebouncedSearchInputProps) => {
  const {
    searchInput,
    handleSearchInputChange,
    handleSearchInputClear,
    handleSearch,
  } = useDebouncedSearch({ setDebouncedSearchInput: onDebouncedInputChange });

  return (
    <SearchTextInput
      label="KOL"
      full
      value={searchInput}
      onChange={handleSearchInputChange}
      onSearch={handleSearch}
      onClear={handleSearchInputClear}
    />
  );
};
